// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2tpjg","name":"styles_name__A3RKI","phone":"styles_phone__2GwP-"};